<script setup lang="ts">
import { formatNumber } from "chartjs-graph";
import { ComparisonCellState } from "@/modules/explorer/components/QuickFilter/quickFilterTools";

/**
 * Renders a single comparison-column cell for the Default and Hierarchy quick filters,
 * given a pre-computed state (see `getComparisonCellState`): a loading indicator, "n/a"
 * when the backend never returned this comparison for the document, or the formatted value.
 */
defineProps<{
	state: ComparisonCellState;
	format?: string;
}>();
</script>

<template>
	<v-progress-linear
		v-if="state.status === 'loading'"
		height="3"
		style="width: 30px"
		bg-color="transparent"
		indeterminate
	/>
	<span v-else-if="state.status === 'unavailable'" class="text-disabled">n/a</span>
	<template v-else>{{ formatNumber(state.value, format) }}</template>
</template>
